VjsAdmin.AdminCleverSyncQueue = SafeDOM.makeAdminQueueModule({ // eslint-disable-line no-undef
    tableSelector: '#cleversync-table',
    formatNoMatchesMsg: 'No cleversync records AT ALL!!!',
    urlRoute: 'admin.cleversync.queue.json',
    idField: 'queue_id',
    queuedDateField: 'date_queued',
    responseHandlerCfg: {
        rowIdField: 'queue_id',
        moveToFrontIdParam: 'queue_id',
        hasClassesRow: true,
        cancelPermission: 'platforms.districts.cleversync.queue.cancel',
        cancelRoute: 'platforms.districts.cleversync.queue.cancel',
        moveToFrontPermission: 'admin.cleversync.queue.moveToFront',
        moveToFrontRoute: 'admin.cleversync.queue.moveToFront',
        viewPermission: 'platforms.districts.cleversync.queue.view',
        viewRoute: 'platforms.districts.cleversync.queue.view',
    },
});
